module.exports = __webpack_public_path__ + "static/media/general-mills.2f8c59eb.png";